export enum SmsTemplateNames {
  smsLrpQuote = 'smsLrpQuote',
}
